/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramAvailableFeaturesUserControllerPromoteMutationRequest,
  TelegramAvailableFeaturesUserControllerPromoteMutationResponse,
  TelegramAvailableFeaturesUserControllerPromote401,
} from '../../types/TelegramAvailableFeaturesUserControllerPromote.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramAvailableFeaturesUserPromote } from '../../methods/telegramAvailableFeaturesUserPromote.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramAvailableFeaturesUserPromoteMutationKey = () =>
  [{ url: '/api/user/telegram/available-features/promote' }] as const;

export type TelegramAvailableFeaturesUserPromoteMutationKey = ReturnType<
  typeof telegramAvailableFeaturesUserPromoteMutationKey
>;

/**
 * {@link /api/user/telegram/available-features/promote}
 */
export function useTelegramAvailableFeaturesUserPromote<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramAvailableFeaturesUserControllerPromoteMutationResponse,
      ResponseErrorConfig<TelegramAvailableFeaturesUserControllerPromote401>,
      { data: TelegramAvailableFeaturesUserControllerPromoteMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramAvailableFeaturesUserControllerPromoteMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramAvailableFeaturesUserPromoteMutationKey();

  return useMutation<
    TelegramAvailableFeaturesUserControllerPromoteMutationResponse,
    ResponseErrorConfig<TelegramAvailableFeaturesUserControllerPromote401>,
    { data: TelegramAvailableFeaturesUserControllerPromoteMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramAvailableFeaturesUserPromote(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
